<template>
  <div class="container">
    <!-- Modal -->
      <div class="modal fade modal-exibir-notificacao" id="exibirNotificacao" role="dialog">
        <div class="modal-dialog">
        <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h1 class="modal-title">Resposta do fornecedor</h1>
            </div>
             <div class="modal-body alert-body">
               <div class="row">
                  <div class="form-group border-blocos validacao_status_notificacao_id">
                      <label class="col-xs-12 col-sm-4 col-md-4">Você concorda com a notificação apresentada?<i class="text-danger">*</i></label>
                    <div class="input-group col-xs-12 col-sm-8 col-md-8">
                      <div class="row">
                          <div class="col-xs-12 col-sm-4 col-md-4 option-first">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="2" v-model="formExibirNotificacoes.status_notificacao_id.valor">
                            <label class="form-check-label" for="inlineRadio1">Concordo</label>
                          </div>
                          <div class="col-xs-12 col-sm-4 col-md-4 option-first">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="3" v-model="formExibirNotificacoes.status_notificacao_id.valor">
                            <label class="form-check-label" for="inlineRadio2">Nao Concordo</label>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="form-group border-blocos validacao_observacao_fornecedor">
                      <label class="col-xs-12 col-sm-4 col-md-4">Justifique<i class="text-danger">*</i></label>
                    <div class="input-group col-xs-12 col-sm-8 col-md-8">
                        <div class="row">
                            <div class="col-xs-12 col-sm-8 col-md-8 option-first">
                                <textarea
                                  v-model="formExibirNotificacoes.observacao_fornecedor.valor"
                                  :placeholder="formExibirNotificacoes.observacao_fornecedor.placeholder"
                                  class="form-control" rows="3" 
                                ></textarea>
                            </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>

            <div class="modal-footer" >
              <button
                v-on:click="salvarFormularioExibirNotificacoes()"
                type="button" class="btn btn-primary pull-right" data-dismiss="modal"
                v-if="controlerBtnSubmit">Salvar
              </button>
              <button type="button" class="btn btn-primary btn-submit" disabled v-else><i class='fa fa-refresh fa-spin'></i> aguarde...</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      formExibirNotificacoes: {
        notificacao_id: {nome: 'notificacao_id', valor: null},
        status_notificacao_id: {nome: 'status_notificacao_id', valor: null},
        observacao_fornecedor: {nome: 'observacao_fornecedor', placeholder: 'Inserir justificativa', valor: null}
      },
      controlerBtnSubmit: true,
      env: process.env
    }
  },
  methods: {
    salvarFormularioExibirNotificacoes () {
      let vm = this
      this.controlerBtnSubmit = false
      this.$axios.post(`${this.env.FINANCEIRO.NOTIFICACAO}/salvarRespostaFornecedor`, this.preencherFormData(), {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`,
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        if (response.status === 200 || response.status === 201) {
          vm.$store.commit('setAlert', {msg: `Resposta salva com sucesso.`, status: true, show: true})
          vm.$store.commit('setNotificacaoAtual', response.data)
        } else {
          vm.$store.commit('setAlert', {msg: `Resposta não foi salva.`, status: false, show: true})
        }
        vm.limparDadosFormulario()
        document.getElementById('exibirNotificacao').click()
        vm.controlerBtnSubmit = true
      }).catch(error => {
        if (error.response && error.respose !== 500) {
          vm.removerValidacao()
          vm.aplicarValidacao(error.response.data.campos)
        } else {
          vm.$store.commit('setAlert', {alert: {msg: 'Algo deu errado! Tente novamente mais tarde tarde.', status: false, show: true}})
        }
        vm.controlerBtnSubmit = true
      })
    },
    aplicarValidacao (erros) {
      erros.forEach((nomeCampo, indice) => {
        let validacao = document.querySelector(`.validacao_${nomeCampo}`)
        validacao.classList.add('preenchimento-obrigatorio')
      })
      this.controlerBtnSubmit = true
      this.$store.commit('setAlert', {alert: {msg: 'Existem campos a serem preenchidos', status: false, show: true}})
      return false
    },
    removerValidacao () {
      for (let campo in this.formExibirNotificacoes) {
        if (this.formExibirNotificacoes[campo].valor !== null || this.formExibirNotificacoes[campo].valor !== '' && campo !== 'notificacao_id') {
          let validacao = document.querySelector(`.validacao_${campo}`)
          validacao.classList.remove('preenchimento-obrigatorio')
        }
      }
    },
    preencherFormData () {
      let formData = new FormData()
      formData.append('notificacao_id', this.$store.state.notificacaoAtual.notificacaoAtual.id)
      formData.append('status_notificacao_id', this.formExibirNotificacoes.status_notificacao_id.valor)
      formData.append('observacao_fornecedor', this.formExibirNotificacoes.observacao_fornecedor.valor)
      formData.append('name', this.$store.state.login.loginUsuario.usuario.name)
      formData.append('email', this.$store.state.login.loginUsuario.usuario.email)
      formData.append('uf_selecionada', JSON.stringify(this.$store.state.notificacaoAtual.notificacaoAtual.uf_id))
      formData.append('tipo_imovel_servico', JSON.stringify(this.$store.state.notificacaoAtual.notificacaoAtual.tipo_imovel_servico_id))
      return formData
    },
    limparDadosFormulario () {
      this.formExibirNotificacoes.status_notificacao_id.valor = ''
      this.formExibirNotificacoes.observacao_fornecedor.valor = ''
      this.removerValidacao()
    }
  }
}

</script>
<style scoped src="../css/modalFormExibirNotificacao.css"></style>



// WEBPACK FOOTER //
// ModalFormExibirNotificacao.vue?4a93e2f2